window.addEventListener('load', async () => {

  const productRecommendationsSections = document.querySelectorAll('.js-product-recommendations');

  for (const productRecommendationsSection of productRecommendationsSections) {
    const url = productRecommendationsSection.dataset.url;

    await fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.js-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });

    const swiperEl = productRecommendationsSection?.querySelector(".js-swiper")
    const nextEl = productRecommendationsSection?.querySelector(".js-next")
    const prevEl = productRecommendationsSection?.querySelector(".js-prev")

    if (swiperEl) {
        const swiper = new Swiper(swiperEl, {
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
            },
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                1024: {
                    slidesPerView: 4,
                }
            }
        })
    }
  }
      
})